var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-bdf610186567e509224ddd134655642d.svg#icon-arrow-d05e5';
                    var viewUrl = 'svg-sprite-bdf610186567e509224ddd134655642d.svg#view-icon-arrow-d05e5';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };